import { render, staticRenderFns } from "./ServiceBehavioralRecord.vue?vue&type=template&id=7ef56cf2&scoped=true"
import script from "./ServiceBehavioralRecord.vue?vue&type=script&lang=js"
export * from "./ServiceBehavioralRecord.vue?vue&type=script&lang=js"
import style0 from "./ServiceBehavioralRecord.vue?vue&type=style&index=0&id=7ef56cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef56cf2",
  null
  
)

export default component.exports